export default {
      id: "expense-icon-usage",
      viewBox: "0 0 37.396 42.336",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#expense-icon",
      toString: function () {
        return this.url;
      }
    }